/*
 * Preggie Mengenrabatt-Block
 * -------------------------------------------------------------
 * Staffel direkt ueber dem Kaufbutton.
 *
 * Bis 05.08.2026 hat der Block nur die Menge in das
 * Produktformular geschrieben. Drei Stueck landeten dadurch als
 * eine Zeile mit Menge 3 im Warenkorb, immer dieselbe Variante.
 *
 * Seit 05.08.2026:
 *   1. Ab Stufe 2 erscheint je Stueck eine eigene
 *      Variantenauswahl. Zeile 1 ist mit der Variantenauswahl
 *      des Themes gekoppelt, damit Preis, Bild und Kaufbutton
 *      dazu passen. Die uebrigen Zeilen sind frei waehlbar.
 *   2. Der Kaufbutton wird abgefangen und legt die gewaehlten
 *      Stuecke selbst in den Warenkorb.
 *
 * Seit 06.08.2026 werden dabei gleiche Varianten gebuendelt:
 * dreimal Beige/L ist eine Zeile mit Menge 3, Beige/L plus
 * zweimal Schwarz/M sind zwei Zeilen. Vorher trug jedes Stueck
 * unter _pqt eine eigene laufende Nummer, damit Shopify die
 * Zeilen nicht zusammenlegt, und dadurch stand auch die
 * haeufigste Bestellung dreimal untereinander im Warenkorb,
 * waehrend dasselbe ueber das normale Mengenfeld eine Zeile
 * ergibt. Die Angabe ist ersatzlos entfallen, sie hatte weder
 * im Theme noch in einer Rabattlogik je einen Leser.
 *
 * Der Rabatt bleibt Sache der Rabattautomatiken: je Produkt eine
 * Automatik mit Mindestmenge 2 bzw. 3, gebunden an das Produkt,
 * nicht an eine Variante. Die Mindestmenge zaehlt alle Stuecke
 * des Produkts im Warenkorb, unabhaengig von Variante und
 * Zeilenaufteilung. Drei Zeilen zu je einem Stueck erfuellen sie
 * also genauso wie eine Zeile mit Menge 3, auch bei drei
 * verschiedenen Farben, und der Prozentsatz greift je Zeile
 * genau einmal. Der Rabatt wird dadurch weder doppelt noch gar
 * nicht berechnet, die Endsumme ist dieselbe wie vorher.
 *
 * Ausverkaufte Kombinationen bleiben je Zeile sichtbar, werden
 * aber beschriftet und gesperrt. Wie das bewertet wird, steht
 * bei hasAvailableForPrefix.
 *
 * Hier steht kein Preis und keine Produkt- oder Varianten-ID im
 * Code. Stufen kommen aus den Metafeldern, Varianten und Preise
 * aus dem JSON-Block, den 'preggie-qty-tiers' rendert.
 *
 * Focal baut den Produktbereich bei jedem Variantenwechsel neu
 * auf und gleicht dabei das bestehende DOM an das frische
 * Server-HTML an. Dabei faellt die getroffene Auswahl auf den
 * Startzustand zurueck. Ein Beobachter stellt sie danach wieder
 * her, eigene Schreibvorgaenge loesen ihn nicht aus. Stufe und
 * Auswahl liegen zusaetzlich ausserhalb des Skript-Scopes, damit
 * sie auch eine erneute Ausfuehrung ueberleben.
 *
 * Die Warenkorb-Anbindung folgt den Events, die Focal 12.5
 * selbst nutzt: variant:added, cart:updated, cart:refresh mit
 * der Section "mini-cart". Gleiches Vorgehen wie in
 * preggie-pdp-bundle.js.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-pqt]';
  var SOLDOUT_SUFFIX = ' · ausverkauft';

  var widget = null;
  var applying = false;
  var scheduled = false;
  var mirroring = false;
  var stateObserver = null;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function themeSettings() {
    return (window.themeVariables && window.themeVariables.settings) || {};
  }

  function currentIndex() {
    var stored = parseInt(window.__pqtIndex, 10);
    return isNaN(stored) ? 0 : stored;
  }

  function setIndex(index) {
    window.__pqtIndex = index;
  }

  function money(cents) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + whole + ',' + parts[1];
  }

  /* Shopify verteilt Prozentrabatte je Stueck und schneidet auf
     ganze Cent ab. Genauso rechnen wir, sonst weicht die
     angezeigte Ersparnis um Cents vom Warenkorb ab. */
  function savings(price, pct, qty) {
    return Math.floor((price * pct) / 100) * qty;
  }

  function sameOptions(variantOptions, chosen) {
    if (!variantOptions || variantOptions.length !== chosen.length) return false;
    for (var i = 0; i < chosen.length; i++) {
      if (String(variantOptions[i]) !== String(chosen[i])) return false;
    }
    return true;
  }

  function findVariant(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      if (sameOptions(variants[i].o, chosen)) return variants[i];
    }
    return null;
  }

  function hasAvailable(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].a && sameOptions(variants[i].o, chosen)) return true;
    }
    return false;
  }

  /* Ein Optionswert gilt als kaufbar, sobald es irgendeine
     kaufbare Variante gibt, die zu den Auswahlen LINKS davon
     passt. Was rechts davon steht, zaehlt bewusst nicht mit.

     Sonst sperrt eine bereits gewaehlte Groesse eine ganze Farbe
     weg. Bei der Umstandshose gibt es Coffee Brown nur in L, mit
     Groesse M im Feld stand die Farbe selbst als ausverkauft da
     und war nicht anwaehlbar. Jetzt bleibt die Farbe waehlbar,
     gesperrt wird nur die Groesse, und die Zeile springt auf die
     kaufbare Groesse derselben Farbe. */
  function hasAvailableForPrefix(variants, chosen, index, value) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (!variant.a || !variant.o) continue;
      if (String(variant.o[index]) !== String(value)) continue;

      var matches = true;
      for (var j = 0; j < index; j++) {
        if (String(variant.o[j]) !== String(chosen[j])) { matches = false; break; }
      }
      if (matches) return true;
    }
    return false;
  }

  /* Gehoert das Bedienelement des Themes zu dieser Option? Focal
     setzt data-option-position, aeltere Staende nur den Namen. */
  function belongsToOption(el, position) {
    var attr = el.getAttribute('data-option-position');
    if (attr) return attr === String(position);
    return el.name === 'option' + position;
  }

  /* Der sichtbare Wert eines Bedienelements des Themes.
     Farbfelder tragen im value die ID des Optionswerts, der
     lesbare Name steht in der zugehoerigen Beschriftung. */
  function optionValueOf(el, index) {
    if (el.tagName === 'SELECT') {
      var option = el.options[index != null ? index : el.selectedIndex];
      return option ? (option.textContent || '').trim() : '';
    }
    if (el.id) {
      var label = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]');
      if (label) return (label.textContent || '').trim();
    }
    var wrapping = el.closest('label');
    if (wrapping) return (wrapping.textContent || '').trim();
    return el.value;
  }

  function Widget(root) {
    this.root = root;
    this.productId = root.getAttribute('data-product-id') || '';
    this.count = root.querySelector('[data-pqt-count]');
    this.bar = root.querySelector('[data-pqt-bar]');
    this.pills = toArray(root.querySelectorAll('[data-pqt-pill]'));
    this.saves = toArray(root.querySelectorAll('[data-pqt-save]'));
    this.arrows = toArray(root.querySelectorAll('[data-pqt-arrow]'));
    this.picksRoot = root.querySelector('[data-pqt-picks]');
    this.pickRows = toArray(root.querySelectorAll('[data-pqt-pick]'));
    this.tierCount = parseInt(root.getAttribute('data-tier-count'), 10) || this.pills.length;
    this.basePrice = parseInt(root.getAttribute('data-base-price'), 10) || 0;
    this.variants = this.parseVariants();
    this.variantIds = this.variants.map(function (variant) { return String(variant.id); });
    this.busy = false;
    if (currentIndex() >= this.pills.length) setIndex(0);
    this.bind();
  }

  Widget.prototype.parseVariants = function () {
    var node = this.root.querySelector('[data-pqt-variants]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  };

  Widget.prototype.forms = function () {
    var ids = this.variantIds;
    return toArray(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (form) {
      var input = form.querySelector('[name="id"]');
      return input && ids.indexOf(String(input.value)) !== -1;
    });
  };

  /* Die vom Theme gewaehlte Variante. Das Formularfeld "id" ist
     die verlaesslichste Quelle, es steht nach jedem Wechsel
     richtig. */
  Widget.prototype.themeVariant = function () {
    var forms = this.forms();
    for (var i = 0; i < forms.length; i++) {
      var input = forms[i].querySelector('[name="id"]');
      if (!input) continue;
      for (var j = 0; j < this.variants.length; j++) {
        if (String(this.variants[j].id) === String(input.value)) return this.variants[j];
      }
    }
    return this.variants[0] || null;
  };

  /* Preis der aktuell gewaehlten Variante, sonst der Preis, mit
     dem die Seite gerendert wurde. */
  Widget.prototype.unitPrice = function () {
    var variant = this.themeVariant();
    return (variant && variant.p) || this.basePrice;
  };

  Widget.prototype.quantityAt = function (index) {
    var pill = this.pills[index];
    return pill ? parseInt(pill.getAttribute('data-qty'), 10) || 1 : 1;
  };

  /* Menge in jedes Formular dieses Produkts schreiben, auch in
     die Sticky-Leiste. Fehlt das Feld, wird es angelegt.
     Sicherheitsnetz fuer jeden Kaufweg, den wir nicht abfangen
     koennen, etwa einen Express-Kaufbutton. */
  Widget.prototype.writeQuantity = function (quantity) {
    this.forms().forEach(function (form) {
      var input = form.querySelector('[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
      }
      if (input.value !== String(quantity)) {
        input.value = quantity;
        if (input.type !== 'hidden') input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  /* ---------- Auswahl je Stueck ---------- */

  Widget.prototype.rowSelects = function (row) {
    return toArray(row.querySelectorAll('[data-pqt-option]')).sort(function (a, b) {
      return parseInt(a.getAttribute('data-pqt-option'), 10) - parseInt(b.getAttribute('data-pqt-option'), 10);
    });
  };

  Widget.prototype.rowValues = function (row) {
    return this.rowSelects(row).map(function (select) { return select.value; });
  };

  Widget.prototype.setRowValues = function (row, values) {
    this.rowSelects(row).forEach(function (select, i) {
      if (values[i] != null && select.value !== values[i]) select.value = values[i];
    });
  };

  Widget.prototype.rowVariant = function (row) {
    return findVariant(this.variants, this.rowValues(row));
  };

  /* Sperrt und beschriftet, was mit den Auswahlen links davon
     nicht kaufbar ist. Faellt die Kombination der Zeile ganz aus,
     etwa nach einem Farbwechsel, wird von links nach rechts so
     viel wie moeglich stehen gelassen und der Rest auf die erste
     kaufbare Kombination gestellt. Die Farbe hat damit Vorrang
     vor der Groesse.

     Zeile 1 wird nicht umgestellt, sie gehoert der
     Variantenauswahl des Themes: eine ausverkaufte Variante darf
     dort stehen bleiben, der Kaufbutton ist dann ohnehin
     gesperrt. */
  Widget.prototype.markRow = function (row, allowFix) {
    var selects = this.rowSelects(row);
    var variants = this.variants;
    if (!selects.length || !variants.length) return;

    var chosen = selects.map(function (select) { return select.value; });

    if (allowFix && !hasAvailable(variants, chosen)) {
      for (var keep = chosen.length - 1; keep >= 0; keep--) {
        var picked = null;

        for (var i = 0; i < variants.length && !picked; i++) {
          var variant = variants[i];
          if (!variant.a || !variant.o) continue;

          var matches = true;
          for (var j = 0; j < keep; j++) {
            if (String(variant.o[j]) !== String(chosen[j])) { matches = false; break; }
          }
          if (matches) picked = variant;
        }

        if (picked) {
          for (var k = 0; k < selects.length; k++) {
            if (picked.o[k] != null) selects[k].value = picked.o[k];
          }
          chosen = selects.map(function (select) { return select.value; });
          break;
        }
      }
    }

    selects.forEach(function (select, index) {
      toArray(select.options).forEach(function (option) {
        var available = hasAvailableForPrefix(variants, chosen, index, option.value);
        option.disabled = !available;
        var label = available ? option.value : option.value + SOLDOUT_SUFFIX;
        if (option.textContent !== label) option.textContent = label;
      });
    });
  };

  Widget.prototype.storedPicks = function () {
    var stored = window.__pqtPicks;
    if (!stored || stored.product !== this.productId || !Array.isArray(stored.rows)) return [];
    return stored.rows;
  };

  /* Sichtbare Zeilen an die gewaehlte Stufe angleichen. Eine
     Zeile wird nur beim ersten Erscheinen vorbelegt, danach
     gehoert ihr Wert der Kundin. */
  Widget.prototype.syncPicks = function (quantity) {
    var self = this;
    if (!this.pickRows.length) return;

    var themeVariant = this.themeVariant();
    var themeValues = themeVariant && themeVariant.o ? themeVariant.o.slice() : null;
    var stored = this.storedPicks();

    this.pickRows.forEach(function (row, i) {
      var visible = i < quantity;
      if (row.hidden === visible) row.hidden = !visible;
      if (!visible) return;

      if (i === 0) {
        if (themeValues) self.setRowValues(row, themeValues);
        self.markRow(row, false);
        return;
      }

      if (row.getAttribute('data-pqt-ready') !== '1') {
        var values = stored[i] || themeValues;
        if (values) self.setRowValues(row, values);
        row.setAttribute('data-pqt-ready', '1');
      }
      self.markRow(row, true);
    });

    if (this.picksRoot) {
      var show = quantity > 1;
      if (this.picksRoot.classList.contains('is-visible') !== show) {
        this.picksRoot.classList.toggle('is-visible', show);
      }
    }

    var rows = [];
    this.pickRows.forEach(function (row, i) {
      rows[i] = i < quantity ? self.rowValues(row) : (stored[i] || null);
    });
    window.__pqtPicks = { product: this.productId, rows: rows };
  };

  /* Sucht im Formular des Themes das Bedienelement, das diesen
     Wert anbietet, und loest dort eine Aenderung aus. Die
     Variantenauswahl haengt in Focal ueber das Attribut "form"
     am Formular und nicht im Formular, deshalb form.elements
     statt querySelectorAll. Findet sich nichts, wird das
     Formularfeld "id" direkt gesetzt. */
  Widget.prototype.pushToTheme = function (form, position, value) {
    var controls = form.elements ? toArray(form.elements) : [];
    var i;
    var j;

    for (i = 0; i < controls.length; i++) {
      var radio = controls[i];
      if (radio.type !== 'radio' || !radio.closest || radio.closest(ROOT_SELECTOR)) continue;
      if (!belongsToOption(radio, position)) continue;
      if (optionValueOf(radio) !== value && radio.value !== value) continue;
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    for (i = 0; i < controls.length; i++) {
      var select = controls[i];
      if (select.tagName !== 'SELECT' || !select.closest || select.closest(ROOT_SELECTOR)) continue;
      if (!belongsToOption(select, position)) continue;
      for (j = 0; j < select.options.length; j++) {
        if (optionValueOf(select, j) !== value && select.options[j].value !== value) continue;
        if (select.selectedIndex !== j) {
          select.selectedIndex = j;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }

    var variant = this.pickRows.length ? this.rowVariant(this.pickRows[0]) : null;
    var idInput = form.querySelector('[name="id"]');
    if (variant && idInput && String(idInput.value) !== String(variant.id)) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return false;
  };

  /* Zeile 1 an die Variantenauswahl des Themes weiterreichen. */
  Widget.prototype.pushFirstRowToTheme = function () {
    if (mirroring || !this.pickRows.length) return;
    var self = this;
    var row = this.pickRows[0];
    var selects = this.rowSelects(row);

    mirroring = true;
    try {
      this.forms().forEach(function (form) {
        selects.forEach(function (select) {
          self.pushToTheme(form, select.getAttribute('data-pqt-option'), select.value);
        });
      });
    } finally {
      mirroring = false;
    }
  };

  /* Der Express-Kaufbutton geht am Warenkorb vorbei und kann nur
     eine Variante mit einer Menge tragen. Sobald die Stuecke
     nicht mehr alle dieselbe Variante sind, wuerde er etwas
     anderes kaufen als auf der Seite steht. Er wird deshalb nur
     in diesem Fall ausgeblendet. */
  Widget.prototype.picksAreMixed = function (quantity) {
    if (quantity < 2 || this.pickRows.length < 2) return false;
    var first = JSON.stringify(this.rowValues(this.pickRows[0]));
    for (var i = 1; i < quantity && i < this.pickRows.length; i++) {
      if (JSON.stringify(this.rowValues(this.pickRows[i])) !== first) return true;
    }
    return false;
  };

  Widget.prototype.syncExpressButtons = function (quantity) {
    var hide = this.picksAreMixed(quantity);
    toArray(document.querySelectorAll('.shopify-payment-button')).forEach(function (el) {
      var hidden = el.getAttribute('data-pqt-hidden') === '1';
      if (hide && !hidden) {
        el.setAttribute('data-pqt-hidden', '1');
        el.style.display = 'none';
      } else if (!hide && hidden) {
        el.removeAttribute('data-pqt-hidden');
        el.style.display = '';
      }
    });
  };

  /* ---------- Anzeige ---------- */

  Widget.prototype.render = function () {
    var index = currentIndex();
    var price = this.unitPrice();
    var quantity = this.quantityAt(index);

    if (this.count && this.count.textContent !== String(quantity)) {
      this.count.textContent = quantity;
    }

    if (this.bar) {
      var percent = (((index + 1) / this.tierCount) * 100).toFixed(2) + '% 100%';
      if (this.bar.style.backgroundSize !== percent) this.bar.style.backgroundSize = percent;
    }

    this.pills.forEach(function (pill, i) {
      var active = i === index;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    this.arrows.forEach(function (arrow, i) {
      arrow.classList.toggle('is-reached', i <= index);
    });

    this.saves.forEach(function (save) {
      var i = parseInt(save.getAttribute('data-pqt-save'), 10);
      var qty = parseInt(save.getAttribute('data-qty'), 10) || 0;
      var pct = parseInt(save.getAttribute('data-pct'), 10) || 0;
      var amount = savings(price, pct, qty);
      var text;

      if (i === index) {
        text = '🤑 du sparst ' + money(amount);
        save.classList.add('is-active');
      } else if (i < index) {
        text = '';
        save.classList.remove('is-active');
      } else {
        text = 'Spare ' + money(amount);
        save.classList.remove('is-active');
      }
      if (save.textContent !== text) save.textContent = text;
    });

    this.syncPicks(quantity);

    if (this.root.style.display !== 'block') this.root.style.display = 'block';
    this.writeQuantity(quantity);
    this.syncExpressButtons(quantity);
  };

  Widget.prototype.bind = function () {
    var self = this;

    this.pills.forEach(function (pill, i) {
      pill.addEventListener('click', function (event) {
        event.preventDefault();
        setIndex(i);
        apply();
      });
    });

    this.pickRows.forEach(function (row, i) {
      self.rowSelects(row).forEach(function (select) {
        select.addEventListener('change', function () {
          if (i === 0) {
            self.pushFirstRowToTheme();
            window.setTimeout(scheduleApply, 0);
          }
          apply();
        });
      });
    });
  };

  /* ---------- Kaufen ---------- */

  /* Die Set-Auswahl auf der Bundle-Seite faengt denselben
     Kaufbutton ab und hat Vorrang. */
  function setModeActive() {
    var input = document.querySelector('[data-pset] [data-pset-mode="set"]');
    return !!(input && input.checked);
  }

  /* Gleiche Variante wird zu einer Zeile mit Menge n
     zusammengefasst, verschiedene Varianten bleiben getrennt.

     Frueher trug jedes Stueck unter _pqt eine eigene laufende
     Nummer, damit Shopify die Zeilen nicht zusammenlegt. Das
     traf aber auch den haeufigsten Fall: dreimal dieselbe Farbe
     in derselben Groesse stand dreimal untereinander im
     Warenkorb, waehrend dasselbe ueber das normale Mengenfeld
     als eine Zeile mit Menge 3 erscheint. Seit dem 06.08.2026
     wird deshalb hier gebuendelt und die Angabe entfaellt.

     Auf die Staffel wirkt das nicht. Die Rabatte sind
     Shopify-Automatiken mit einer Mindestmenge je Produkt, und
     die zaehlt ueber den ganzen Warenkorb. Ob drei Stueck als
     3x1 oder 1x3 dort liegen, ist ihr gleich. _pqt hatte
     ausserdem nie einen Leser, weder im Theme noch in einer
     Rabattlogik. */
  Widget.prototype.buildItems = function (quantity) {
    var fallback = this.themeVariant();
    var items = [];
    var byVariant = {};

    for (var i = 0; i < quantity; i++) {
      var row = this.pickRows[i];
      var variant = row ? this.rowVariant(row) : null;
      if (!variant) variant = fallback;
      if (!variant) continue;

      var key = String(variant.id);
      if (byVariant[key]) {
        byVariant[key].quantity += 1;
      } else {
        byVariant[key] = { id: variant.id, quantity: 1 };
        items.push(byVariant[key]);
      }
    }

    return items;
  };

  Widget.prototype.submitButtons = function (form) {
    var buttons = toArray(form.querySelectorAll('[type="submit"]'));
    if (form.id) {
      toArray(document.querySelectorAll('[form="' + form.id + '"][type="submit"]')).forEach(function (button) {
        if (buttons.indexOf(button) === -1) buttons.push(button);
      });
    }
    return buttons;
  };

  Widget.prototype.submitTier = function (form, quantity) {
    var self = this;
    if (this.busy) return;

    var items = this.buildItems(quantity);
    if (!items.length) return;

    this.busy = true;
    var buttons = this.submitButtons(form);
    buttons.forEach(function (button) { button.setAttribute('aria-busy', 'true'); });
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var root = routeRoot();
    var settings = themeSettings();

    var done = function () {
      self.busy = false;
      buttons.forEach(function (button) { button.removeAttribute('aria-busy'); });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    };

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: ['mini-cart'] })
    }).then(function (response) {
      return response.json().then(function (json) { return { ok: response.ok, json: json }; });
    }).then(function (result) {
      if (!result.ok) {
        done();
        form.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true,
          detail: { error: result.json && result.json.description }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }

      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        window.location.href = root + 'cart';
        return;
      }

      var added = result.json.items ? result.json.items[0] : result.json;
      form.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: added } }));

      return fetch(root + 'cart.js').then(function (response) {
        return response.json();
      }).then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        cart.sections = result.json.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cart,
            openMiniCart: settings.cartType === 'drawer' && form.closest('.drawer') === null
          }
        }));
        done();
      });
    }).catch(function () {
      done();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  };

  /* ---------- Ablauf ---------- */

  /* Zustand schreiben und die dabei entstehenden Mutationen aus
     dem Beobachter nehmen, damit er sich nicht selbst ausloest. */
  function apply() {
    if (!widget || !document.contains(widget.root)) return;
    applying = true;
    widget.render();
    if (stateObserver) stateObserver.takeRecords();
    applying = false;
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      apply();
    };
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 16);
    }
  }

  /* Block aus dem Variantenbereich heraus direkt ueber die
     Kaufbuttons haengen und erst dann sichtbar machen. */
  function place(root) {
    var scope = root.closest('.product-form') || root.closest('.product__info');
    var anchor = null;

    if (scope) {
      anchor = scope.querySelector('.product-form__buy-buttons') || scope.querySelector('form[action*="/cart/add"]');
    }
    if (!anchor) {
      anchor = document.querySelector('.product__info .product-form__buy-buttons');
    }
    if (anchor && anchor.parentNode && !anchor.closest('product-sticky-form')) {
      anchor.parentNode.insertBefore(root, anchor);
    }

    root.setAttribute('data-pqt-placed', '1');
    root.style.display = 'block';

    if (stateObserver) stateObserver.disconnect();
    if (window.MutationObserver) {
      stateObserver = new MutationObserver(function () {
        if (applying) return;
        scheduleApply();
      });
      stateObserver.observe(root, { childList: true, subtree: true, attributes: true, characterData: true });
    }
  }

  function sync() {
    toArray(document.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      if (widget && widget.root === root) return;

      if (widget && document.contains(widget.root)) {
        if (root.parentNode) root.parentNode.removeChild(root);
        return;
      }

      widget = new Widget(root);
      place(root);
      apply();
    });
  }

  document.addEventListener('variant:changed', scheduleApply);
  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.closest) return;
    if (event.target.closest(ROOT_SELECTOR)) return;
    scheduleApply();
  });

  /* Kaufbutton abfangen und jedes Stueck als eigene Zeile
     anlegen. Bei einem Stueck bleibt alles beim Alten, dann
     macht das Theme den Warenkorb-Aufruf selbst. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!widget || !document.contains(widget.root)) return;

    var input = form.querySelector('[name="id"]');
    if (!input || widget.variantIds.indexOf(String(input.value)) === -1) return;

    var quantity = widget.quantityAt(currentIndex());

    /* Absicherung: unmittelbar vor dem Absenden noch einmal die
       Menge setzen, falls das Theme das Feld zwischendurch
       zurueckgesetzt hat. */
    widget.writeQuantity(quantity);

    if (quantity < 2) return;
    if (setModeActive()) return;

    var submitter = event.submitter || document.activeElement;
    if (submitter && submitter.closest && submitter.closest('.shopify-payment-button')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    widget.submitTier(form, quantity);
  }, true);

  /* Nachgelieferte Kopien aus einem Neuaufbau einsammeln. */
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if ((node.matches && node.matches(ROOT_SELECTOR)) || (node.querySelector && node.querySelector(ROOT_SELECTOR))) {
            sync();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:block:select', sync);
})();
